export default __webpack_public_path__ + "static/media/steel.bc63c58e.svg";